import React from 'react'
import { FaCopyright } from 'react-icons/fa'

const Footer = () => {
  return (
    <div className='footer-section'>
      <hr />
        <div className="copy">
          <FaCopyright/>Ssekitto-Shafiq 2022 All Rights reserved
        </div>
    </div>
  )
}

export default Footer